import dayjs from "./dayjs";

export const renderRelativeTimestamp = (dateString: string) => {
  const date = dayjs.utc(dateString);
  const ageInMinutes = dayjs().diff(dayjs(dateString), "minute");
  if (ageInMinutes < 1) return "just now";
  if (ageInMinutes < 60) return `${ageInMinutes}m ago`;
  const ageInHours = Math.floor(ageInMinutes / 60);
  if (ageInHours < 24) return `${ageInHours}h ago`;
  if (ageInHours < 24 * 7) return `${Math.floor(ageInHours / 24)}d ago`;
  return date.format("MMM D, YYYY");
};
